var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 2.264 6.513-.887.002 6.282-6.51.037L0 2.264Zm6.51 6.119.004 6.287-6.509-.895V8.341l6.504.042Zm.789-7.122 8.635-1.26v7.578l-8.635.069V1.26Zm8.637 7.181-.002 7.544-8.635-1.219-.012-6.34 8.649.015Z"
  })));
};
export default SvgMicrosoft;